import styled from 'styled-components'
import { Field } from 'formik'
import Textarea from 'share-ui/components/Textarea/Textarea'
import { useEffect, useRef } from 'react'
import FieldLabel from 'share-ui/components/FieldLabel/FieldLabel'

type TextareaProps = {
    setFieldValue?: any
    label: string
    value: string
    fieldName: string
    triggerResize?: number
    minHeight?: number
    placeholder?: string
}

const TextareaFormik = ({
    label,
    value,
    fieldName,
    triggerResize,
    minHeight,
    ...props
}: TextareaProps) => {
    const textareaRef = useRef(null as any)
    const input_name = fieldName

    useEffect(() => {
        const textarea = textareaRef.current
        if (textarea) {
            // console.log('SHOULD RESIZE')
            // textarea.style.height = 'auto' // Reset the height to auto to recalculate the height
            // textarea.style.height = `${textarea.scrollHeight}px` // Set the height to the scroll height of the content
            setTimeout(function () {
                textarea.style.height = 'auto' // Reset the height to auto to recalculate the height
                textarea.style.height = `${textarea.scrollHeight}px`
            }, 100)
        }
    }, [value, triggerResize])

    return (
        <Field name={input_name}>
            {(formik: any) => {
                const { field, meta, form } = formik
                const onHandleChange = (e: any) => {
                    form.setFieldValue(field.name, e)
                }
                return (
                    <StyledTextareaWrapper minHeight={minHeight}>
                        <FieldLabel labelText={label} />
                        <Textarea
                            ref={textareaRef}
                            hint=''
                            value={value}
                            onChange={onHandleChange}
                            maxLenght={10000}
                            validation={
                                meta.touched
                                    ? {
                                          text: meta.error,
                                          status: meta.error && 'error',
                                      }
                                    : undefined
                            }
                            {...props}
                        />
                    </StyledTextareaWrapper>
                )
            }}
        </Field>
    )
}

export default TextareaFormik

const StyledTextareaWrapper = styled.div<{ minHeight?: number }>`
    line-height: 22px;
    font-size: 10px;

    display: flex;
    flex-direction: column;

    textarea {
        min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '100px')};
        max-height: calc(100vh - 400px);
    }
`
